import { getQuery } from 'utilities/query';

export default class IngredientService {
  constructor($http) {
    'ngInject';

    this.$http = $http;
  }

  getDefaultSystemIngredientQuery() {
    return {
      ...getQuery(),
      take: 200,
      orderBy: 'SystemIngredientName',
      direction: 'asc'
    };
  }

  getDefaultUserIngredientQuery() {
    return {
      ...getQuery(),
      take: 200,
      orderBy: 'UserIngredientName',
      direction: 'asc'
    };
  }

  searchSystemIngredients(query) {
    return this.$http.get('/odata/SystemIngredientOData', {
      params: {
        $select: 'SystemIngredientId, SystemIngredientName, IUtoMgConversiontRate',
        ...query.top && { $top: query.take },
        ...query.calculateSkip && { $skip: query.calculateSkip() },
        $orderby: `${query.orderBy} ${query.direction}`,
        ...query.filter && { $filter: query.filter.toString() },
        $count: true
      }
    });
  }

  searchUserIngredients(query) {
    return this.$http.get('/odata/UserIngredientOData', {
      params: {
        $select: 'UserIngredientId, UserIngredientName, ProductCount',
        $top: query.take,
        $skip: query.calculateSkip(),
        $orderby: `${query.orderBy} ${query.direction}`,
        ...query.filter && { $filter: query.filter.toString() },
        $count: true
      }
    });
  }

  addSystemIngredientMapping(systemIngredientId, userIngredientIds) {
    return this.$http.post(`/api/system_ingredient/${systemIngredientId}/user_ingredients`, {
      systemIngredientId,
      userIngredientIds
    });
  }

  removeSystemIngredientMapping(systemIngredientId, userIngredientIds) {
    return this.$http.delete(`/api/system_ingredient/${systemIngredientId}/user_ingredients`, {
      data: {
        systemIngredientId,
        userIngredientIds
      }
    });
  }
}



// WEBPACK FOOTER //
// ./services/ingredient.service.js